
import { AiFillCloseCircle } from 'react-icons/ai'
import { Close } from '../CustomIcons';
import "./style.css";

function CloseButton({ className = "", onClick, style={} }) {
    return (
        <div id="custom-close-button" style={style} className={className} onClick={() => {
            onClick();
        }}>
            <Close/>
        </div>
    );
}

export default CloseButton;